import { z } from 'zod';

export enum UserRole {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
  THIRD_PARTY = 'third-party',
}

export const UserRoleSchema = z.nativeEnum(UserRole);
